<template>
    <page>
        <module :title="id ? '编辑特殊价格申请' : '新建特殊价格申请'">
            <c-form ref="form">
                <c-form title="会员信息">
                    <c-form-item label="目标用户" required>
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.memberSelector.open()">添加用户</c-button>
                        </m-operate>

                        <c-table ref="memberList" v-model="memberList" height="300" :paging="false" border>
                            <c-table-column
                                    label="用户名"
                                    name="login_name"
                            ></c-table-column>

                            <c-table-column
                                    label="手机号"
                                    name="user_manage_mobilephone"
                            ></c-table-column>

                            <c-table-column
                                    label="注册时间"
                                    name="create_date"
                            ></c-table-column>

                            <c-table-column
                                    required
                                    label="生效时间"
                                    width="150"
                            >
                                <template v-slot="row">
                                    <c-datetime v-model="row.data.begin_time" ></c-datetime>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    required
                                    label="生效结束时间"
                                    width="150"
                            >
                                <template v-slot="row">
                                    <c-datetime v-model="row.data.end_time"></c-datetime>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                            >
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
                <c-form title="管控方式">
                    <c-form-item type="radio" label="" name="type" v-model="type" :options="typeOptions" required word="请选择价格管控的类型" ></c-form-item>
                </c-form>
                <c-form title="品牌" v-show="type == 2">
                    <c-form-item label="目标品牌" v-show="type == 2" required>
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.brandSelector.open()">添加品牌</c-button>
                        </m-operate>

                        <c-table ref="brandList" v-model="brandList" height="auto" :paging="false" border>
                            <c-table-column
                                    label="品牌名称"
                                    name="brand_name"
                                    width="120"
                            ></c-table-column>

                          <c-table-column
                              label="折扣"
                              width="100"
                          >
                            <template v-slot="{data}">
                              <c-input decimal="1" :limit="[0.1,9.9]" v-model="data.discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                            </template>
                          </c-table-column>


                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="100"
                            >
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
                <c-form title="商品" v-show="type == 1">
                    <c-form-item label="目标商品" v-show="type == 1" required>
                        <m-operate>
                          <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                        </m-operate>
                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                        <c-table-column
                            label="商品信息"
                            name="product_name"
                            width="200"
                        >
                          <template v-slot="{data}">
                            <div class="flex-center">
                              <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                              <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
                            </div>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="商品货号"
                            name="product_itemnumber"
                        ></c-table-column>

                        <c-table-column
                            label="价格"
                            name="product_price"
                            width="140"
                        >
                          <template v-slot="{data}">
                            ￥{{data.product_price_min}}
                            <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="折扣"
                            width="100"
                        >
                          <template v-slot="{data}">
                            <c-input decimal="1" :limit="[0.1,9.9]" v-model="data.discount" width="80" type="number" style="margin: 0 5px;" word="折"></c-input>
                          </template>
                        </c-table-column>

                        <c-table-column
                            label="促销价"
                            name="promotion_price"
                            width="140"
                        >
                          <template v-slot="{data}">
                            <span v-if="data.discount" >
                                      ￥{{parseFloat(data.product_price_min * data.discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.discount / 10).toFixed(2)}}
                                      </span>
                            </span>
                          </template>
                        </c-table-column>

                        <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                        >
                          <template v-slot="row">
                            <c-table-button @click="row.remove()">删除</c-table-button>
                          </template>
                        </c-table-column>
                      </c-table>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button size="m" @click="submit(1)">确定提交</c-button>
                <c-button size="m" hollow @click="submit(0)">暂存草稿</c-button>
            </template>
        </module>

        <member-selector ref="memberSelector" multiple @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-selector>
        <brand-selector ref="brandSelector" multiple @resolve="selectHandle($event, 'brandList', 'id')"></brand-selector>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import memberSelector from '@/components/service/member_selector.vue'
    import brandSelector from '@/components/service/brand_selector.vue'
    import {mapState} from 'vuex'
    import productSelector from "@/components/service/product_selector";

    export default {
        name: 'special_price_edit',

        components: {
            memberSelector, brandSelector,productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                memberList: [],
                brandList: [],
                productList: [],
                type: 1,/**类型 2：品牌 1：商品**/
                typeOptions: [
                  {name: '按商品',value: 1},
                  {name: '按品牌',value: 2}
              ],
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getDetail();
            }
        },

        mounted() {
            this.id && this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/special_price/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        this.memberList = data.user_list || [];
                        this.brandList = data.brand_list || [];
                        this.productList = data.product_list || [];
                        this.type = data.type || 1;
                    }
                });
            },

            selectHandle(list, ref, key) {
                list = list.filter(item => {
                    return !this[ref].find(row => {
                        return row[key] == item[key];
                    });
                });
                this[ref] = this[ref].concat(list);
            },
            /***
             * 选择商品
             * @param list
             */
            productSelectHandle(list) {
              list = list.filter(item => {
                return !this.productList.find(row => {
                  return row.product_id == item.product_id;
                });
              });
              this.productList = this.productList.concat(list);
            },

            submit(state) {
                console.log(this.productList)
                this.$refs.form.submit({
                    url: this.id ? '/special_price/edit' : '/special_price/add',
                    rule: {
                        member_list: [{
                            type: 'function',
                            fun: () => {
                                return !!this.memberList.length;
                            },
                            word: '请选择目标用户'
                        }],
                        member_config: [{
                            type: 'function',
                            fun: () => {
                                return !this.memberList.find(item => {
                                    return !item.begin_time || !item.end_time;
                                });
                            },
                            word: '请设置生效时间以及生效结束时间'
                        }],
                        brand_list: [{
                          type: 'function',
                          fun: () => {
                            if(this.type == 2){
                              return !!this.brandList.length;
                            }else return true;
                          },
                          word: '请至少添加一个品牌'
                        }],
                        brand_config: [{
                            type: 'function',
                            fun: () => {
                              if(this.type == 2){
                                  return !this.brandList.find(item => {
                                    return !item.discount;
                                  });
                              }else return true;
                            },
                            word: '请设置品牌折扣信息'
                        }],
                        product_list: [{
                          type: 'function',
                          fun: () => {
                            if(this.type == 1){
                              return !!this.productList.length;
                            }else return true;
                          },
                          word: '请至少添加一件商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                              if(this.type == 1){
                                  return !this.productList.find(item => {
                                    return !item.discount;
                                  });
                              }else return true;
                            },
                            word: '请设置折商品扣信息'
                        }],
                    },
                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.type = this.type;
                        data.state = state;
                        data.user_list = Array.from(this.memberList, item => {
                            return {
                                id: item.platform_user_id,
                                begin_time: item.begin_time,
                                end_time: item.end_time,
                            }
                        });
                        if(this.brandList) {
                            data.brand_list = Array.from(this.brandList, item => {
                              return {
                                id: item.id,
                                discount: item.discount
                              }
                            });
                        }
                        if(this.productList) {
                            data.product_list = Array.from(this.productList, item => {
                              return {
                                product_id: item.product_id,
                                discount: item.discount
                              }
                            });
                        }
                        return data;
                    },

                    success: () => {
                        this.$message({
                            text: '保存成功'
                        });
                        this.$bus.$emit('specialPriceList.update', {});
                        this.redirectTo('/special_price_list');
                    }
                })
            }
        }
    }
</script>